import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@telegram-apps/telegram-ui/dist/styles.css';
import './index.css';

import { installMockEnvIfNeeded } from './mockEnv';
import { init } from './init';
import { App } from './App';

installMockEnvIfNeeded();

void init({ debug: import.meta.env.DEV }).finally(() => {
    const rootEl = document.getElementById('root');
    if (!rootEl) {
        throw new Error('#root element not found in index.html');
    }
    createRoot(rootEl).render(
        <StrictMode>
            <App />
        </StrictMode>,
    );
});
